import { render, staticRenderFns } from "./ModalFair.vue?vue&type=template&id=1557764f&scoped=true"
import script from "./ModalFair.vue?vue&type=script&lang=js"
export * from "./ModalFair.vue?vue&type=script&lang=js"
import style0 from "./ModalFair.vue?vue&type=style&index=0&id=1557764f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1557764f",
  null
  
)

export default component.exports